exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-import-object-history > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {\n  padding-bottom: 0;\n}\n.project-import-object-history > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box .ant-table-pagination.ant-pagination {\n  margin-bottom: 0;\n}\n", ""]);

// exports
